import { useEffect } from "react";
import AOS from "aos";

//* Components
import AboutCareerPlusSection from "../../components/pages/Index/AboutCareerPlusSection";
import WhoCanApplySection from "../../components/pages/Index/WhoCanApplySection";
import ProcessSection from "../../components/pages/Index/ProcessSection";
import CalenderSection from "../../components/pages/Index/CalenderSection";
import SlideBannerSection from "../../components/pages/Index/SlideBannerSection";
import CareerPlusWebSliderSection from "../../components/pages/Index/CareerPlusWebSliderSection";
import ParticipantsSection from "../../components/pages/Index/ParticipantsSection";
import UserCardsSection from "../../components/pages/Index/UserCardsSection";
import FooterSection from "../../components/pages/Index/FooterSection";
import FAQSection from "../../components/pages/Index/FAQSection";
import MainVideoSection from "../../components/pages/Index/MainVideoSection";
import Loading from "../../components/pages/Index/Loading";

const Main = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ paddingTop: "95px" }}>
      <Loading />
      <MainVideoSection />
      <AboutCareerPlusSection />
      <WhoCanApplySection />
      <ProcessSection />
      <CalenderSection />
      <SlideBannerSection />
      <ParticipantsSection />
      <UserCardsSection />
      <FAQSection />
      <FooterSection />
    </div>
  );
};

export default Main;
